/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoTwitterIcon24Solid = forwardRef('LogoTwitterIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M19.48 4.817a1.25 1.25 0 0 0-1.892-1.634l-4.96 5.743-4.143-5.48A1.125 1.125 0 0 0 7.588 3H4.504a1.125 1.125 0 0 0-.898 1.803l5.874 7.769-5.71 6.61a1.25 1.25 0 1 0 1.892 1.635l5.36-6.206 4.493 5.942c.212.282.544.447.897.447h3.084c.93 0 1.458-1.063.898-1.804l-6.224-8.23 5.31-6.15Z" })));
});
